// extracted by mini-css-extract-plugin
export default {"form":"classic_onboarding_layout_form__5FO8J","scrollableContainer":"classic_onboarding_layout_scrollableContainer__emZMn","footer":"classic_onboarding_layout_footer__WfStz"};